// GA event metadata for the itinerary engagement feature — like/dislike/
// share on the itinerary itself, plus the full comments thread (reactions,
// replies, edit/delete, and the composer in its three modes: new/edit/reply).
// Enum keys must match GA_LABEL_ENUMS in GAEvents.ts; labels are the
// hyphenated strings shipped to Google Analytics.
export const comments_events = {
  // Itinerary-level engagement bar
  itinerary_details_itinerary_like: {
    category: "Itinerary engagement",
    action: "User likes the itinerary",
    label: "itinerary-details-itinerary-like",
  },
  itinerary_details_itinerary_dislike: {
    category: "Itinerary engagement",
    action: "User dislikes the itinerary",
    label: "itinerary-details-itinerary-dislike",
  },
  itinerary_details_itinerary_comment: {
    category: "Itinerary engagement",
    action: "User clicks the comments chip on the itinerary",
    label: "itinerary-details-itinerary-comment",
  },

  // Per-comment reactions and reply
  itinerary_comment_like: {
    category: "Comment engagement",
    action: "User likes a comment",
    label: "itinerary-comment-like",
  },
  itinerary_comment_dislike: {
    category: "Comment engagement",
    action: "User dislikes a comment",
    label: "itinerary-comment-dislike",
  },
  itinerary_comment_reply: {
    category: "Comment engagement",
    action: "User opens the reply composer on a comment",
    label: "itinerary-comment-reply",
  },

  // Per-comment kebab (options) menu
  itinerary_comment_options_click: {
    category: "Comment options",
    action: "User opens the kebab menu on their comment",
    label: "itinerary-comment-options-click",
  },
  itinerary_comment_options_edit_click: {
    category: "Comment options",
    action: "User selects Edit from the kebab menu",
    label: "itinerary-comment-options-edit-click",
  },
  itinerary_comment_options_delete_click: {
    category: "Comment options",
    action: "User selects Delete from the kebab menu",
    label: "itinerary-comment-options-delete-click",
  },
  itinerary_comment_options_delete_yes: {
    category: "Comment options",
    action: "User confirms deleting a comment",
    label: "itinerary-comment-options-delete-yes",
  },
  itinerary_comment_options_delete_no: {
    category: "Comment options",
    action: "User cancels deleting a comment via the No button",
    label: "itinerary-comment-options-delete-no",
  },
  itinerary_comment_options_delete_close: {
    category: "Comment options",
    action: "User dismisses the delete-comment confirmation dialog",
    label: "itinerary-comment-options-delete-close",
  },

  // Thread expand / collapse
  itinerary_comment_show_replies_click: {
    category: "Comment thread",
    action: "User expands replies under a comment",
    label: "itinerary-comment-show-replies-click",
  },
  itinerary_comment_hide_replies_click: {
    category: "Comment thread",
    action: "User collapses replies under a comment",
    label: "itinerary-comment-hide-replies-click",
  },

  // Composer — new comment (top-level "Add a comment…")
  itinerary_comment_input_click: {
    category: "Comment composer",
    action: "User focuses the top-level comment input",
    label: "itinerary-comment-input-click",
  },
  itinerary_comment_input_cancel_click: {
    category: "Comment composer",
    action: "User cancels the top-level comment input",
    label: "itinerary-comment-input-cancel-click",
  },
  itinerary_comment_input_post_click: {
    category: "Comment composer",
    action: "User posts a top-level comment",
    label: "itinerary-comment-input-post-click",
  },

  // Composer — edit existing comment
  itinerary_comment_edit_input_click: {
    category: "Comment composer",
    action: "User focuses the edit-comment input",
    label: "itinerary-comment-edit-input-click",
  },
  itinerary_comment_edit_cancel_click: {
    category: "Comment composer",
    action: "User cancels the edit-comment input via the Cancel button",
    label: "itinerary-comment-edit-cancel-click",
  },
  itinerary_comment_edit_post_click: {
    category: "Comment composer",
    action: "User saves an edited comment",
    label: "itinerary-comment-edit-post-click",
  },
  itinerary_comment_edit_cancel_x_click: {
    category: "Comment composer",
    action: "User cancels the edit-comment input via the X icon in the draft header",
    label: "itinerary-comment-edit-cancel-x-click",
  },

  // Composer — reply to a comment
  itinerary_comment_reply_input_click: {
    category: "Comment composer",
    action: "User focuses the reply input",
    label: "itinerary-comment-reply-input-click",
  },
  itinerary_comment_reply_cancel_click: {
    category: "Comment composer",
    action: "User cancels the reply input via the Cancel button",
    label: "itinerary-comment-reply-cancel-click",
  },
  itinerary_comment_reply_post_click: {
    category: "Comment composer",
    action: "User posts a reply to a comment",
    label: "itinerary-comment-reply-post-click",
  },
  itinerary_comment_reply_cancel_x_click: {
    category: "Comment composer",
    action: "User cancels the reply input via the X icon in the draft header",
    label: "itinerary-comment-reply-cancel-x-click",
  },
};
